import type { FaireProductEntity } from "../../entity_types/product";

export const plant_dyed_4: FaireProductEntity = {
  token: "plant-dyed-4",
  type: "product",
  name: "Shizuku Vegetable Dyed Gauze Towel",
  brandName: "FUKOROA TOWEL",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/4926afa96a65b696e8bbe385937af880968825937a045824f3bbb9c53d02008b.png",
  priceDollars: 27.5,
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/4926afa96a65b696e8bbe385937af880968825937a045824f3bbb9c53d02008b.png",
  weight: 0.3,
  dimensions: {
    width: 14,
    height: 14,
    depth: 0.5,
  },
  description: "Vegetable dyed gauze towel with natural colors",
  categoryTokens: ["cat_accessories"],
  tags: [
    "plant-dyed",
    "natural-dye",
    "sustainable-textiles",
    "vegetable-dye",
    "gauze",
    "premium",
  ],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
